import { renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.$slots.header)
      ? _renderSlot(_ctx.$slots, "header", { key: 0 }, undefined, true)
      : _createCommentVNode("", true),
    _renderSlot(_ctx.$slots, "default", {}, undefined, true),
    (_ctx.$slots.footer)
      ? _renderSlot(_ctx.$slots, "footer", { key: 1 }, undefined, true)
      : _createCommentVNode("", true)
  ]))
}